/**
 * Gloabl set of target to select for lazy loading
 */
export const lazy_loading_targets =
  "img[data-src], img[data-srcset], picture source[data-src], picture source[data-srcset]";

/**
 * Set `src` on image element
 * @param {*} img Image Element
 * @param {boolean} darkModeEnabled Defines if the dark mode has been enabled or disabled to force the visibility of the specific logo variant
 * @param {boolean} contrastManuallySwitched Defines if the contrast was manually switched
 */
export function setSrc(
  img,
  darkModeEnabled = false,
  contrastManuallySwitched = false
) {
  let src;

  if (darkModeEnabled) {
    // --- dark mode ---
    if (img.getAttribute("data-dark-src") === null) {
      if (!contrastManuallySwitched) {
        src = img.getAttribute("data-src");
      }
    } else {
      src = img.getAttribute("data-dark-src");
    }
  } else {
    // --- light mode ---
    if (img.getAttribute("data-light-src") === null) {
      if (!contrastManuallySwitched) {
        src = img.getAttribute("data-src");
      }
    } else {
      src = img.getAttribute("data-light-src");
    }
  }

  // Set `src` only if not `null`
  if (src) {
    img.src = src;
    img.removeAttribute("data-src");
  }

  // src set
  let src_set = img.getAttribute("data-srcset");
  if (src_set && !contrastManuallySwitched) {
    img.srcset = src_set;
    img.removeAttribute("data-srcset");
  }
}
